import { Quote } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { TESTIMONIALS } from "../data/content";

export const Testimonials = () => (
  <section id="testimonials" className="py-28 sm:py-36" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline>Patient Stories</Overline>
        <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-stone-800 max-w-3xl leading-snug">
          Breaths restored. <span className="text-teal-700 italic">Lives returned.</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 2) * 0.1}>
            <figure data-testid={`testimonial-${i + 1}`}
              className="h-full p-8 rounded-2xl border border-[#E3DCCB] bg-[#FFFFFF]/50 relative overflow-hidden group hover:border-teal-500/30 transition-colors duration-500">
              <Quote size={48} className="absolute -top-2 -right-2 text-teal-600/10 group-hover:text-teal-600/20 transition-colors duration-500" />
              <blockquote className="font-serif-display text-lg sm:text-xl text-stone-700 leading-relaxed italic">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 flex items-center justify-between">
                <div>
                  <p className="text-sm font-semibold text-stone-800">{t.name}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{t.meta}</p>
                </div>
                <span className="font-mono-tag text-[10px] uppercase tracking-[0.2em] px-3 py-1.5 rounded-full border border-teal-500/30 text-teal-700">
                  {t.tag}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-8 text-center font-mono-tag text-[10px] uppercase tracking-[0.25em] text-stone-400">
          Sample stories shown — replace with your verified patient testimonials
        </p>
      </Reveal>
    </div>
  </section>
);
